import { Component, ElementRef, EventEmitter, Input, OnInit, OnChanges, Output } from '@angular/core';
import {ProductModel} from '../models/product.model';

@Component({
  selector: 'app-accessory-details-headers',
  template: `
    <div class="d-none d-lg-block d-xl-block container row" style="width:100%;">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top: 2%; margin-bottom: 2%;" >
        <h1 class="headerTitle">{{this.model.type}} Accessories</h1>
          <div class="headerType">
            {{this.model.title}} Accessories
          </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top: 2%; margin-bottom: 2%;">
        <img class="headerImage" alt="LG Home Comfort" src="http://www.lghomecomfort.com/AssetsPM/SiteProductCategoryImage/general/215/ceilingmounted_singlezone_badge.jpeg" />
      </div>
  </div>
  <div class="d-lg-none d-xl-none" style="width:100%">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top: 2%; margin-bottom: 2%;">
      <img class="headerImage" alt="LG Home Comfort" src="http://www.lghomecomfort.com/AssetsPM/SiteProductCategoryImage/general/215/ceilingmounted_singlezone_badge.jpeg" />
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top: 2%; margin-bottom: 2%;" >
      <div class="headerTitle">{{this.model.type}} Accessories</div>
        <div class="headerType">
          {{this.model.title}} Accessories
        </div>
    </div>
  </div>
  
  `,
  styles: [
    `
    .headerTitle {
      color: #A50034;	
      font-family: "LGEIBold";
      font-size: 40px;	
      text-align: left;
    }

    .headerType {
      color: #4A4A4A;	
      font-family: 'LGEIRegular';
      font-size: 32px;
      text-align: left;
    }

    .headerDescription {
      color: #4A4A4A;	
      font-family: 'LGEIRegular';
      font-size: 28px;	
      font-weight: 300;
      text-align: left;
    }

    .headerImage {
      display: block;
      vertical-align: middle;
      height: 264px;
      width: 335px;
      margin: auto
    }

    @media only screen and (min-width : 769px){
      .row {
        display: flex !important;
      }
    }
    `
  ]
})
export class AccessoryDetailsHeadersComponent {
  @Input() model: ProductModel;


}



// WEBPACK FOOTER //
// ./src/app/product-category/components/accessory-details-headers.component.ts